import React from "react";
import Container from "./Container";
import { Link } from "react-router-dom";
import { LogoHeader1 } from "../assets/img";

const Footer = () => {
  return (
    <>
      <div className="md:bg-secondary">
        <Container>
          <div className="bg-secondary md:bg-none py-12 font-poppins px-4 md:p-auto">
            <div className="grid gap-4 grid-cols-12">
              <div className="col-span-12 md:col-span-6 lg:col-span-4">
                <div className="">
                  <div className="flex items-center">
                    <img src={LogoHeader1} alt="Footer" className="h-[40px]" />
                    <span className="text-white font-semibold ml-2 text-base font-poppins tracking-wide">
                      Sportfolio
                    </span>
                  </div>
                  <p className="text-white mt-3 font-light text-sm">
                    The first decentralized sports exchange to buy ownership in
                    your favorite sports teams, just like stocks.
                  </p>
                </div>
              </div>
              <div className="col-span-6 md:col-span-3 lg:col-span-2">
                <h3 className="font-bold text-white text-base mb-2">Pages</h3>
                <Link
                  className="text-white mt-1 text-sm block font-light"
                  to="#"
                >
                  Home
                </Link>
                <Link
                  className="text-white mt-1 text-sm block font-light"
                  to="#"
                >
                  Betting
                </Link>
                <Link
                  className="text-white mt-1 text-sm block font-light"
                  to="#"
                >
                  Drafts
                </Link>
                <Link
                  className="text-white mt-1 text-sm block font-light"
                  to="#"
                >
                  How it Works
                </Link>
              </div>
              <div className="col-span-6 md:col-span-3 lg:col-span-2">
                <h3 className="font-bold text-white text-base mb-2">
                  Quick Links
                </h3>
                <Link
                  className="text-white mt-1 text-sm block font-light"
                  to="#"
                >
                  Privacy Policy
                </Link>
                <Link
                  className="text-white mt-1 text-sm block font-light"
                  to="#"
                >
                  Term of Use
                </Link>
                <Link
                  className="text-white mt-1 text-sm block font-light"
                  to="#"
                >
                  Age Restrictions
                </Link>
                <Link
                  className="text-white mt-1 text-sm block font-light"
                  to="#"
                >
                  Team
                </Link>
              </div>
              <div className="col-span-12 lg:col-span-4 w-full">
                <div className="flex flex-col gap-5 w-full">
                  <h2 className="uppercase text-base text-white font-bold">
                    Stay in the loop
                  </h2>
                  <div className="flex flex-col sm:flex-row items-center justify-start gap-2 lg:gap-0 w-full pr-4 sm:pr-0">
                    <input
                      type="text"
                      name="letterBox"
                      placeholder="Enter Your Email Address"
                      className="bg-transparent w-full sm:w-[242px] md:w-[255px] border border-white/90 rounded px-3 py-[10px] text-sm font-medium focus:outline-none text-white"
                    />

                    <button className="w-full sm:w-[86px] lg:w-[104px] border border-yellow-400  bg-yellow-400 text-black rounded px-2 md:px-3 py-[10px] text-sm font-medium lg:-ml-5 whitespace-nowrap">
                      Sign Up
                    </button>
                  </div>

                  <div className="flex items-center justify-start gap-12 lg:gap-18 xlg:gap-24">
                    <h3 className="font-semibold text-base text-white">
                      Follow us :{" "}
                    </h3>
                    <div className="flex items-center justify-center gap-4">
                      <div className="w-6 h-6 bg-white rounded-full flex items-center justify-center text-secondary text-base">
                        <i className="fab fa-twitter"></i>
                      </div>
                      <div className="w-6 h-6 bg-white rounded-full flex items-center justify-center text-secondary text-base">
                        <i className="fab fa-facebook-f"></i>
                      </div>
                      <div className="w-6 h-6 bg-white rounded-full flex items-center justify-center text-secondary text-base">
                        <i className="fab fa-instagram"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Footer;
